import {ModuleInitPhase, ScreenParameters} from '@gongxigames/framework/core';
import {SystemPopup} from '@gongxigames/framework/slot/types';
import {HTMLSystemPopupsView, ReactSystemPopupsView, SystemPopupsManagerEvents} from './index';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {BaseView} from '@gongxigames/framework/slot/fragments/module/view/BaseView';

export interface ISystemPopupView {
    init(screenParameters: ScreenParameters): void;
    destroy(): void;
    show(popup: SystemPopup): void;
    hide(popup: SystemPopup): void;
    hideCurrentPopup(): void;
    resize(screenParameters: ScreenParameters): void;
}

export class SystemPopupsView extends BaseView<SystemPopupsManagerEvents> {
    public static NAME = Symbol('SystemPopupsView');
    public static initPhase: ModuleInitPhase = 'initial';
    public static layer = LAYERS.SYSTEM_POPUPS;

    protected views: ISystemPopupView[] = [];

    public init(): void {
        super.init();

        this.views.push(
            new HTMLSystemPopupsView(this._settings.get('platform')),
            new ReactSystemPopupsView()
        );

        this.views.forEach(view => view.init(this._screenManager.getScreenState()));
    }

    public showPopup(popup: SystemPopup): void {
        this.views.forEach(view => {
            view.show(popup);
        });

        this.emit('SystemPopupsManager.POPUP_SHOWN');
    }

    public hidePopup(popup: SystemPopup): void {
        this.views.forEach(view => {
            view.hide(popup);
        });

        this.emit('SystemPopupsManager.POPUP_HID');
    }

    public hideCurrentPopup(): void {
        this.views.forEach(view => {
            view.hideCurrentPopup();
        });
    }

    public onOrientationChanged(): void {
        this.resize();
    }

    public onResized(screenParams: ScreenParameters): void {
        this.resize(screenParams);
    }

    public resize(screenParams: ScreenParameters = this._screenManager.getScreenState()): void {
        this.views.forEach(view => {
            view.resize(screenParams);
        });
    }

    public destroy(): void {
        super.destroy();

        this.views.forEach(view => view.destroy());
    }
}
